export const getCurrentLoadedBilling = (state, clubId) => {
  if (!clubId) return null;

  const normalizedClubId = String(clubId);

  if (
    state?.clubId === normalizedClubId &&
    state?.loaded === true &&
    !state?.error &&
    String(state?.billing?.clubId) === normalizedClubId
  ) {
    return state.billing;
  }

  return null;
};

export const hasConfirmedDisabledBillingRollout = (state, clubId) => {
  const billing = getCurrentLoadedBilling(state, clubId);

  return billing?.billingEnabled === false;
};

export const shouldRedirectDisabledBillingRoute = (
  state,
  clubId,
  isUserSuperAdmin
) =>
  !isUserSuperAdmin && hasConfirmedDisabledBillingRollout(state, clubId);
